/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Renderer2,
  forwardRef,
  Inject,
  OnInit
} from '@angular/core';
import { Menu } from 'primeng/menu';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MenuItem, OverlayService, PrimeNGConfig } from 'primeng/api';
import { PLATFORM_ID } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'm-menu',
  templateUrl: './m-menu.component.html',
  styleUrls: ['./m-menu.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MMenuComponent),
      multi: true
    }
  ]
})
export class MMenuComponent extends Menu implements OnInit {
  @Input() menuItems: MenuItem[] = [];
  @Input() override disabled: any = false;
  @Input() buttonBadge = '';
  @Input() override ariaLabel = '';
  @Input() showArrow = true;
  @Input() override id = '';
  @Input() menuStyle: 'menu-default' | '' = '';
  @Input() iconPlacement: 'left' | 'right' = 'right';

  public isMenuOpen = false;

  constructor(
    @Inject(DOCUMENT) document: Document,
    @Inject(PLATFORM_ID) platformId: any,
    el: ElementRef,
    renderer: Renderer2,
    cd: ChangeDetectorRef,
    config: PrimeNGConfig,
    overlayService: OverlayService
  ) {
    super(document, platformId, el, renderer, cd, config, overlayService);
  }

  onMenuOpen(): void {
    this.isMenuOpen = true;
  }

  onMenuClose(): void {
    this.isMenuOpen = false;
  }

  override ngOnInit(): void {
    this.menuItems.forEach((item) => {
      if (item.styleClass === 'menu-default') {
        item.styleClass = 'menu-default';
      }
    });
    super.ngOnInit();
  }
}
